import React from 'react';
import { FilterMatchMode } from "primereact/api";
import { Tag } from 'primereact/tag';

export class ActividadEconomicaModel {
    model = {
        nemonico: {
            header: 'Código',
            filterField: 'nemonico',
            table: true,
            filter: true,
            sort: true,
            filterPlaceholder: 'Buscar código...',
            matchMode: FilterMatchMode.CONTAINS,
            style: { width: '160px', textAlign: 'left' },
            alignHeader: 'center',
            body: (rowData) => (
                <Tag value={rowData.nemonico || ''} severity="info" className="font-mono text-xs px-3 py-1 shadow-1" style={{ borderRadius: '6px' }} />
            )
        },
        nombre: {
            header: 'Actividad Económica',
            filterField: 'nombre',
            table: true,
            filter: true,
            sort: true,
            filterPlaceholder: 'Buscar por nombre o palabra clave...',
            matchMode: FilterMatchMode.CONTAINS,
            style: { minWidth: '350px' },
            body: (rowData) => (
                <div className="flex align-items-center gap-2">
                    <i className="pi pi-briefcase text-primary text-base opacity-70" />
                    <span className="font-medium text-800 line-height-3">
                        {rowData.nombre}
                    </span>
                </div>
            )
        }
    };
}